import { EntityType, compareArrays } from '@frontend/common';
import { ProductCategoryClient } from '@frontend/group/api';
import { MultiGroupSelect } from '@frontend/group/select';
import { GroupMember, IGroup, NodeType } from '@frontend/group/types';
import { CommonMessage } from '@frontend/lang';
import { updateField } from '@frontend/repository';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';
import { useLinkCategoriesModal } from './link-categories-modal.controller';

const LINK_CATEGORIES_FORM_ID = 'link-categories-form';

export interface LinkCategoriesModalProps {
    groups: IGroup[];
    members: GroupMember[];
    entity_id: string;
    entity_type: EntityType;
    callback?: () => void;
}

export const LinkCategoriesModal = (props: LinkCategoriesModalProps) => {
    const viewProps = useLinkCategoriesModal(props);
    return (
        <UpdateModal<GroupMember[], { groups: string[] }>
            onSubmit={async (value) => {
                const { add, remove } = compareArrays(
                    props.groups.map((g) => g.id),
                    value.groups
                );
                const results = await Promise.all([
                    ...add.map((category_id) =>
                        ProductCategoryClient.postProductCategoryMember(viewProps.currentAccount, category_id, {
                            entity_id: props.entity_id,
                            entity_type: props.entity_type
                        })
                    ),
                    ...remove.map((group_id) =>
                        ProductCategoryClient.deleteProductCategoryMember(
                            viewProps.currentAccount,
                            group_id,
                            props.members.find((m) => m.group_id === group_id)!.id
                        )
                    )
                ]);
                props.callback && props.callback();
                return Promise.resolve(results.filter((r) => r !== undefined) as GroupMember[]);
            }}
            formId={LINK_CATEGORIES_FORM_ID}
            order={[]}
            label={CommonMessage.BUTTONS.EDIT(CommonMessage.OBJECTS.PRODUCT_CATEGORY.DEFAULT)}
            type={EntityType.PRODUCT_CATEGORY}
            values={{ groups: viewProps.categories }}
            append={
                <MultiGroupSelect
                    type={EntityType.PRODUCT_CATEGORY}
                    value={viewProps.categories}
                    queryParams={{ node_type: NodeType.BRANCH }}
                    onChange={(v) => {
                        viewProps.setCategories(v);
                        viewProps.dispatch(updateField({ formId: LINK_CATEGORIES_FORM_ID, key: 'categories', value: v }));
                    }}
                />
            }
        />
    );
};
